/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_LostInputs */

const cs_deals_lost = /** @type {(inputs: Deals_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohráno`)
};

const en_deals_lost = /** @type {(inputs: Deals_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost`)
};

/**
* | output |
* | --- |
* | "Lost" |
*
* @param {Deals_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_lost = /** @type {((inputs?: Deals_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_lost(inputs)
	return cs_deals_lost(inputs)
});